/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import {
  GetContactsResponseData,
  GetContactsResponseDataFromJSON,
  GetContactsResponseDataFromJSONTyped,
  GetContactsResponseDataToJSON
} from './GetContactsResponseData'

/**
 *
 * @export
 * @interface GetContactsResponse
 */
export interface GetContactsResponse {
  /**
   *
   * @type {number}
   * @memberof GetContactsResponse
   */
  status?: number
  /**
   *
   * @type {GetContactsResponseData}
   * @memberof GetContactsResponse
   */
  data?: GetContactsResponseData
}

export function GetContactsResponseFromJSON(json: any): GetContactsResponse {
  return GetContactsResponseFromJSONTyped(json, false)
}

export function GetContactsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactsResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    status: !exists(json, 'status') ? undefined : json['status'],
    data: !exists(json, 'data') ? undefined : GetContactsResponseDataFromJSON(json['data'])
  }
}

export function GetContactsResponseToJSON(value?: GetContactsResponse | null): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    status: value.status,
    data: GetContactsResponseDataToJSON(value.data)
  }
}
